<template>
  <!-- 日志列表 -->
  <div class="dialog-root">
    <div class="container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="listData"
        :page.sync="tablePage"
        :search.sync="searchForm"
        @search-change="searchChange"
        @search-reset="searchReset"
        @on-load="loadData"
      >
        <template slot="importTimeSearch">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 100%"
          >
          </el-date-picker>
        </template>
        <template slot="importType" slot-scope="{ row }">
          <span>{{ row.importTypeStr }}</span>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <el-button type="text" size="small" @click="download(row)">下载 </el-button>
        </template>
      </avue-crud>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/util/auth';
import { getLogListApi } from '@/api/electric-meter/electric-meter-bill';

export default {
  name: 'LogList',
  props: ['rowData'],
  data() {
    return {
      // 搜索条件
      searchForm: {},
      // 搜索条件-起止日期
      dateRange: [],
      // 列表数据
      listData: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 80,
        column: [
          {
            label: '导入批次',
            prop: 'importBatch',
          },
          {
            label: '类型',
            prop: 'importType',
            slot: true,
            search: true,
            type: 'select',
            props: { label: 'dictValue', value: 'dictKey' },
            dicData: [
              {
                dictValue: '充值',
                dictKey: 1,
              },
              {
                dictValue: '扣缴',
                dictKey: 2,
              },
            ],
          },
          {
            label: '导入时间',
            prop: 'importTime',
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '操作',
            prop: 'operation',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      getLogListApi(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            id: this.rowData.id,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {};
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.importTimeStart = this.dayjs(this.dateRange[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.searchForm.importTimeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.searchForm.importTimeStart = '';
        this.searchForm.importTimeEnd = '';
        this.dateRange = [];
      }
    },
    /* 下载 */
    download(item) {
      window.open(
        `/api/v4ward/prePay/electricity/unLegal/exportUnLegalRecord?${
          this.website.tokenHeader
        }=${getToken()}&importBatch=${item.importBatch}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
